<script lang="ts" setup>
import { tpgIconSort } from '@tpg/grammar-web-icons';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import {
  GrammarMenuItem,
  GrammarQuaternaryMenuButton,
} from '@nora-monorepo/grammar-ui';
import { GetAttachmentsForConversationSortByParameter } from '@nora-monorepo/nora-api-client';
import { SortOrder } from '@nora-monorepo/shared';

import type { SortOption } from '#nora-chat-ui/components/modals/files-modal/files-modal.types';

interface AttachmentSortMenuProps {
  selectedSort?: SortOption;
}

defineProps<AttachmentSortMenuProps>();

defineEmits<{
  select: [sortOption: SortOption];
}>();

const { t } = useI18n();

const orderByKeys = Object.values(
  GetAttachmentsForConversationSortByParameter,
);

/**
 * Every sortable field paired with both sort directions.
 */
const sortOptions = computed<SortOption[]>(() => {
  return orderByKeys.flatMap((key) => {
    const orders: SortOrder[] = [SortOrder.ASC, SortOrder.DESC];

    return orders.map((order) => {
      return {
        text: t(`attachments.sort.${String(key)}:${order}`),
        sort: {
          sortBy: key,
          sortOrder: order,
        },
      };
    });
  });
});
</script>

<template>
  <GrammarQuaternaryMenuButton
    :label="selectedSort?.text ?? 'Sort'"
    :icon-template="tpgIconSort"
  >
    <GrammarMenuItem
      v-for="sortOption in sortOptions"
      :key="sortOption.text"
      :label="sortOption.text"
      @select="() => $emit('select', sortOption)"
    />
  </GrammarQuaternaryMenuButton>
</template>
